/**
 * Planet B debug logging — off by default in production.
 * Enable via ?pbdebug=1, localStorage.pb_debug=1, shopify-design-mode, or window.__PB_DEBUG__ = true.
 */
(() => {
  function isEnabled() {
    if (window.__PB_DEBUG__ === true) return true;

    try {
      if (localStorage.getItem('pb_debug') === '1') return true;
    } catch (e) {
      /* private mode / blocked storage */
    }

    try {
      if (new URLSearchParams(location.search).get('pbdebug') === '1') return true;
    } catch (e) {
      /* invalid URL */
    }

    if (document.documentElement?.classList?.contains('shopify-design-mode')) return true;

    return false;
  }

  const enabled = isEnabled();
  window.__PB_DEBUG__ = enabled;

  window.PBDebug = {
    enabled,
    log(...args) {
      if (enabled) console.log(...args);
    },
    warn(...args) {
      if (enabled) console.warn(...args);
    },
  };
})();
